/**
 * GET /api/auth/me tokenLimit:
 * - trial / free / paid (active): positive number
 * - paid (subscription expired): null
 * - undefined: not loaded from API yet
 */
export function getEffectiveTokenLimit(userPlan, tokenLimitFromApi) {
  if (tokenLimitFromApi === undefined) return undefined;
  if (tokenLimitFromApi !== null) {
    const n = Number(tokenLimitFromApi);
    return Number.isFinite(n) ? n : null;
  }
  if (userPlan === 'paid') return null;
  if (userPlan === 'free') return 1000000;
  if (userPlan === 'trial') return 3000000;
  return 0;
}

export function getTokensRemaining(userPlan, totalTokensUsed, tokenLimitFromApi) {
  const limit = getEffectiveTokenLimit(userPlan, tokenLimitFromApi);
  if (limit === undefined) return undefined;
  if (limit === null) return null;
  return Math.max(0, limit - (Number(totalTokensUsed) || 0));
}
